export const DEFAULT_STYLE = {
    height: 320,
    width: 280
};

export const GROUPS = {
    recently_used: true,
    smileys_people: true,
    food_drink: true,
    animals_nature: true,
    activities: true,
    objects: true,
    travel_places: true,
    flags: true,
    symbols: true
};
